import type { QueryFunctionContext } from '@tanstack/react-query';
import { AdminService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { adminJobsKeys } from 'app/queries/adminJobs/adminJobsKeys';
import type { TCall, TCallOptions } from 'app/queries/types/TCall';

type TParams = QueryFunctionContext<ReturnType<typeof adminJobsKeys.utterancesByJob>>;

export const createFetchJobUtterancesQueryFn =
  (call: TCall, options?: TCallOptions) =>
  ({ queryKey: [{ jobId, transcript }], signal }: TParams) =>
    call(() => cancelOnSignal(AdminService.getJobUtterances({ jobId, transcript }), signal), options);
